export const SSO_IN_PROGRESS_LS_KEY = 'ssoInProgress';
